import React, { useState, useEffect } from 'react';
import '../styles/PageLoader.css';

export function PageLoader() {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Keep loader visible for minimum 2 seconds
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  // Don't render at all once hidden
  if (!isVisible) {
    return null;
  }

  return (
    <div className="page-loader-overlay">
      <div className="page-loader-container">
        <div className="page-loader-logo-wrapper">
          <img 
            src="/images/alo_laba_logo.png" 
            alt="Alo@laba" 
            className="page-loader-logo"
          />
          <div className="page-loader-spinner"></div>
        </div>
      </div>
    </div>
  );
}
